import { ClearFilters } from "Components/Users/ClearFilters";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { RootState } from "store";
import { protocolsCreatedByAction } from "store/filters/reducer.actions";
import { filtersInitialState } from "store/filters/initialState";

export const SelectedCreatedBy: React.FC = () => {
  const dispatch = useDispatch();
  const { protocolsFilter } = useSelector<RootState, filtersInitialState>(
    (state) => state.Filters
  );

  const resetFilter = (program: any) => {
    dispatch(protocolsCreatedByAction(program));
  };

  if (protocolsFilter.createdByIds?.applied) {
    return protocolsFilter.createdByIds.value.map(
      (item: any, index: number) => (
        <div
          key={index}
          className="flex justify-between px-2  items-center gap-1 flex-grow-0 flex-shrink-0 relative  
 rounded-lg bg-primary_8"
        >
          <div className="flex justify-center items-center flex-grow-0 flex-shrink-0 relative px-1 pt-1.5 pb-2">
            <p className="flex-grow-0 flex-shrink-0 text-sm text-center text-textMid dark:text-inputText">
              {item.name}
            </p>
          </div>
          <ClearFilters handleClick={() => resetFilter(item)} />
        </div>
      )
    );
  } else {
    return null;
  }
};
